import PropTypes from "prop-types";
// material
import { Box } from "@mui/material";
import { Link } from "react-router-dom";

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object,
};

export default function Logo({ sx }) {
  return (
    <Link to={"/"}>
      <Box
        component="img"
        src="/static/logo2.png"
        sx={{ width: 292, height: 71, ...sx }}
      />
    </Link>
  );
}
